import React, { useEffect } from 'react';

export const ComingSoonView = ({ handleItemSelect, title }: any) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        handleItemSelect({ name: 'Quit' }); // Or simulate a popMenu by sending a non-matching string that handles 'Quit'/'Back'
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleItemSelect]);

  return (
    <div className="flex-1 flex flex-col bg-[#eefcfc]">
      <div className="bg-[#1e8585] text-white px-2 py-1 flex justify-between items-center text-[12px] font-semibold">
        <span>{title || 'Feature Upcoming'}</span>
      </div>
      <div className="flex-1 flex flex-col items-center justify-center m-1 bg-white border border-[#1e8585]">
        <h2 className="text-2xl font-semibold text-gray-700 mb-2">Coming Soon</h2>
        <p className="text-gray-500">This feature is currently under development.</p>
        <p className="text-gray-400 text-sm mt-4">Press ESC to go back</p>
      </div>
    </div>
  );
};
